import { Box, Card, Skeleton, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';

interface OnboardingPromoteTasksSkeletonProps {
  type: 'recommendation' | 'promote';
  itemsCount?: number;
}

function OnboardingPromoteTasksSkeleton({
  type,
  itemsCount = 3,
}: OnboardingPromoteTasksSkeletonProps) {
  return (
    <div
      className={`stratus--onboarding-promote-tasks ${
        type === 'recommendation' ? 'recommendations' : ''
      }`}
    >
      <Card padding="none">
        <DataList>
          {Array.from({ length: itemsCount }).map((_, index) => (
            <DataList.Row key={index} gap="1">
              <Box display="flex" gap="2" justifyContent="space-between">
                <Box display="flex" gap="3" flex="1">
                  <Skeleton width="24px" height="24px" borderRadius="4px" />
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap="1"
                    alignSelf="center"
                    flex="1"
                  >
                    <Text.Skeleton width="40%" />
                    <Text.Skeleton width="90%" />
                  </Box>
                </Box>
                {type === 'promote' && (
                  <Box display="flex" alignItems="center" gap="4">
                    <Text.Skeleton width="60px" />
                    <Skeleton width="24px" height="24px" borderRadius="4px" />
                  </Box>
                )}
                {type === 'recommendation' && (
                  <Skeleton width="24px" height="24px" borderRadius="4px" />
                )}
              </Box>
            </DataList.Row>
          ))}
        </DataList>
      </Card>
    </div>
  );
}

export default OnboardingPromoteTasksSkeleton;
